import { createAction, props } from "@ngrx/store";
import { ActivityReportResponse } from "../models/master-status-view/ActivityReportResponse";
import { masterTransactionsTableTabName } from "../../shared/utilities/Constants";
import { ServiceError } from "../models/shared/ServiceError";
import { JsonApiListWrap } from "../../shared/models/JsonApiWrap";

export const getActivityReports = createAction(
    '[Activity Report Page - API] Get the list of master activity reports',
)

export const callActivityReportsSuccess = createAction(
    '[Activity Report Page - API] Activity Reports Loaded Successfully',
    props<JsonApiListWrap<ActivityReportResponse>>()
)

export const callActivityReportsFailure = createAction(
    '[Activity Report Page - API] Activity Reports NOT Loaded',
    props<ServiceError>()
)

export const hasEmptyActivityReportResponse = createAction(
    '[Activity Report Table] Empty response for table'
);

export const downloadActivityReportClicked = createAction(
  '[Activity Report Page] User requested download of activity report',
  props<{activityReportId: string, interimSequenceId: string}>()
)

export const downloadActivityReportSuccess = createAction(
  '[Activity Report Page - API] Activity report downloaded successfully',
  props<{file: Blob}>()
)

export const downloadActivityReportFailure = createAction(
  '[Activity Report Page - API] Activity report download failed',
  props<ServiceError>()
)